import React from 'react';
import './Note.css';

function Note({ children }) {
    return <div className="Note">{children}</div>;
}

export default Note;
